import $ from 'jquery';

var $accordionToggle = $('.js-accordion-toggle');

$accordionToggle.on('click', function () {
  var $accordion = $(this).closest('.js-accordion');
  var $accordions = $(this).closest('.js-accordions');
  if ($accordion.hasClass('is-toggled')) {
    $accordion.removeClass('is-toggled');
  } else {
    $accordions.find('.is-toggled').removeClass('is-toggled');
    $accordion.addClass('is-toggled');
  }
});
